module.exports = __webpack_public_path__ + "static/media/order_bumps.7eb788dd.svg";